module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tiposEnvio/tiposEnvio.component.html
// module id = ./src/app/tiposEnvio/tiposEnvio.component.html
// module chunks = main